import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { RelationTypeToken } from '@sleed/bizcommerce-api';
import { relationTypesApi } from '~/lib/api/client';
import { formToToken, type RelationTypeFormValues } from '~/lib/schemas/relation-type';

export const relationTypeKeys = {
	all: ['relation-types'] as const,
	list: () => [...relationTypeKeys.all, 'list'] as const
};

export function useRelationTypesList() {
	return useQuery<RelationTypeToken[]>({
		queryKey: relationTypeKeys.list(),
		queryFn: async () => (await relationTypesApi.getAll()).data.items ?? []
	});
}

export function useRelationTypeMutations() {
	const qc = useQueryClient();
	const invalidate = () => qc.invalidateQueries({ queryKey: relationTypeKeys.list() });
	const create = useMutation({
		mutationFn: async (form: RelationTypeFormValues) => (await relationTypesApi.insert(formToToken(form))).data,
		onSuccess: invalidate
	});
	const update = useMutation({
		mutationFn: async (form: RelationTypeFormValues) => (await relationTypesApi.update(formToToken(form))).data,
		onSuccess: invalidate
	});
	const remove = useMutation({ mutationFn: async (id: number) => (await relationTypesApi.remove(id)).data, onSuccess: invalidate });
	return { create, update, remove };
}
